module.exports = __webpack_public_path__ + "static/assets/7e6fc1a7bfd95a5853c9ba9eaf8e35c8.png";